// extracted by mini-css-extract-plugin
export default {"orderModificationSummaryMainContainer":"OrderModificationSummary_orderModificationSummaryMainContainer__jjPSX"};